import { toLower } from "lodash";
import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import DataTable from "PFComponents/data_table/data_table";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import Pill from "PFComponents/pill/pill";
import { ApiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./access_request.less";

const AccessRequestPage = ({ accessRequests, fetch }) => {
  const { t } = useTranslation("admin");
  const { t: tSaas } = useTranslation("sassAdmin");
  const handleStatusChange = (data, status) => {
    if (
      status === "accepted"
        ? confirm(t("accessRequest.confirm.accept", { email: data.email }))
        : confirm(t("accessRequest.confirm.reject"))
    ) {
      $.ajax({
        url: ApiRoute(`/api/admin/access_requests/${data.id}`),
        method: "PUT",
        data: { status: status }
      }).then(() => fetch(accessRequests?.meta?.page));
    }
  };

  const statusRenderer = (data) => {
    switch (data.status) {
      case "accepted":
        return <Pill small>{toLower(t("accepted"))}</Pill>;
      case "rejected":
        return (
          <div className={css.status}>
            <Button small onClick={() => handleStatusChange(data, "accepted")}>
              {t("accessRequest.admin.accept")}
            </Button>
            <Pill small>{toLower(t("rejected"))}</Pill>
          </div>
        );
      case "pending":
        return (
          <div className={css.status}>
            <Button small onClick={() => handleStatusChange(data, "accepted")}>
              {t("accessRequest.admin.accept")}
            </Button>
            <Button small kind="danger" onClick={() => handleStatusChange(data, "rejected")}>
              {t("accessRequest.admin.reject")}
            </Button>
          </div>
        );
    }
  };
  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <h1>{t("accessRequest.header")}</h1>
      </div>
      <PageBox>
        {accessRequests.meta.total > 0 ? (
          <DataTable
            columns={[
              {
                headerName: t("accessRequest.form.email"),
                cellKey: "email"
              },
              {
                headerName: t("accessRequest.form.name"),
                cellKey: "name"
              },
              {
                headerName: t("accessRequest.form.company"),
                cellKey: "company"
              },
              {
                headerName: tSaas("table.status"),
                renderCell: (data) => statusRenderer(data),
                narrow: true
              }
            ]}
            data={accessRequests.entries}
          />
        ) : (
          <div className={css.notFound}>{tSaas("accessRequestNotFound")}</div>
        )}
      </PageBox>
      <div className={css.pagination}>
        <SimplePagination
          currentPage={accessRequests?.meta?.page}
          totalPages={accessRequests?.meta?.totalPages}
          handleClick={fetch}
        />
      </div>
    </div>
  );
};
AccessRequestPage.propTypes = {
  accessRequests: PropTypes.shape({
    meta: PropTypes.shape({
      total: PropTypes.number,
      page: PropTypes.number,
      totalPages: PropTypes.number
    }),
    entries: PropTypes.arrayOf(
      PropTypes.shape({
        company: PropTypes.string,
        created_id: PropTypes.string,
        email: PropTypes.string,
        id: PropTypes.number,
        name: PropTypes.string,
        status: PropTypes.string,
        updated_at: PropTypes.string
      })
    )
  }),
  fetch: PropTypes.func
};
export default AccessRequestPage;
